/* Maison Byōbu · étalon du système d'images (27/10/2026, thème de test seulement). snippets/mb-etalon-galerie.
   - Barre segmentée du carrousel (téléphone) : suit la vue visible.
   - Hauteur de la planche (ordinateur) pour son arrêt en bas d'écran.
   - Agrandissement plein écran ; l'œuvre entière se parcourt du doigt sur téléphone.
   assets/mb-sig-oeuvre.js n'est pas modifié. */
(() => {
  const g = document.querySelector('[data-et-galerie]');
  if (!g || g.dataset.etPret) return;
  g.dataset.etPret = '1';
  const piste = g.querySelector('#sig-piste');
  const vues = [...piste.querySelectorAll('.vue')];
  const segs = [...g.querySelectorAll('.et-segments li')];

  /* ---------- Barre segmentée ---------- */
  const pas = () => (vues.length > 1 ? vues[1].offsetLeft - vues[0].offsetLeft : piste.clientWidth) || 1;
  const indice = () => {
    const max = piste.scrollWidth - piste.clientWidth;
    if (max > 4 && piste.scrollLeft >= max - 4) return vues.length - 1;
    return Math.max(0, Math.min(vues.length - 1, Math.round(piste.scrollLeft / pas())));
  };
  const maj = () => { const i = indice(); segs.forEach((s, k) => s.toggleAttribute('data-on', k === i)); };
  let attente = false;
  piste.addEventListener('scroll', () => { if (!attente) { attente = true; requestAnimationFrame(() => { attente = false; maj(); }); } }, { passive: true });
  addEventListener('resize', maj, { passive: true });
  maj();

  /* ---------- Hauteur de la planche ---------- */
  const hauteur = () => g.style.setProperty('--et-h', g.offsetHeight + 'px');
  if ('ResizeObserver' in window) new ResizeObserver(hauteur).observe(g); else addEventListener('resize', hauteur);
  hauteur();

  /* ---------- Agrandissement ---------- */
  const dlg = document.getElementById('et-zoom');
  if (dlg && typeof dlg.showModal === 'function') {
    const zImg = dlg.querySelector('img');
    const zCadre = dlg.querySelector('.et-zoom__cadre');
    const ouvrir = (b) => {
      dlg.classList.toggle('et-zoom--panorama', b.hasAttribute('data-et-panorama'));
      zImg.src = b.dataset.etZoom;
      document.documentElement.classList.add('et-zoom-ouvert');
      dlg.showModal();
      zCadre.scrollLeft = 0;
    };
    g.querySelectorAll('.et-agrandir').forEach((b) => b.addEventListener('click', () => ouvrir(b)));
    dlg.querySelector('.et-zoom__fermer').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', () => { document.documentElement.classList.remove('et-zoom-ouvert'); zImg.removeAttribute('src'); });
  }
})();